
import Vue from "vue";

import { PaginationOptions, PaginatedResponse } from "@/types/Pagination";
import workflowService from '@/services/admin/workflowService';

export default Vue.extend({
  name: "LeaseRequestList",
  props: {
    readyToApproveOnly: String,
  },
  data: function () {
    return {
      loading: false,
      paginatedResponse: {} as PaginatedResponse<object>,
      menu: false,
      search: '',
      statuses: ["RequestCreated"],
      options: {} as PaginationOptions,
      headers: [
        { text: "#ID", align: "left", value: "requestId" },
        { text: "Submitted at", align: "left", value: "submittedAt" },
        { text: "Requester", align: "left", value: "requester", sortable: false },
        { text: "Status", align: "left", value: "status" },
        { text: "Dog Id", align: "left", value: "dogId" },
        { text: "Start date", align: "left", value: "startDate" },
        { text: "End date", align: "left", value: "endDate" },
      ],
      footerProps: { 'items-per-page-options': [10, 20, 30, 40, 50] }
    };
  },
  created: function () { this.loadList() },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    }
  },
  methods: {
    applyFilters: function () {
      this.menu = false;
      this.loadList();
    },
    loadList: async function () {
      this.loading = true;
      const {
        page,
        itemsPerPage,
      } = this.options;

      const response = await workflowService.getLeaseRegistrationsList({
        ...this.options,
        page: (page ?? 1) - 1,
        itemsPerPage: itemsPerPage ?? 10
      }, this.$data.statuses);

      this.loading = false;
      this.paginatedResponse = response;
    },
    registerLease: function() {
      this.$router.push({path: '/admin/registration/leases/new'});
    },
  },
});
